import { render, staticRenderFns } from "./quotation.vue?vue&type=template&id=593a345a&scoped=true"
import script from "./quotation.vue?vue&type=script&lang=js"
export * from "./quotation.vue?vue&type=script&lang=js"
import style0 from "./quotation.vue?vue&type=style&index=0&id=593a345a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593a345a",
  null
  
)

export default component.exports